import { Box } from "@mui/material";
import React, { Fragment } from "react";

const OmniDeviceLayout = ({ children }) => {
  return (
    <Fragment>
      <Box
        component="div"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          // 100vh on iOS Safari includes the area behind the address bar,
          // so it overstates the real visible viewport on devices/situations
          // where the toolbar is shown (e.g. iPhone XR in the reported bug).
          // 100dvh tracks the ACTUAL visible viewport and updates as the
          // browser chrome shows/hides. -webkit-fill-available is a fallback
          // for iOS versions older than 15.4 that don't support dvh.
          height: "100vh", // fallback for browsers with no dvh support
          "@supports (height: 100dvh)": {
            height: "100dvh",
          },
          minHeight: "-webkit-fill-available",
          p: { xs: 0, sm: 2 },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            boxShadow:
              "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
            height: "100%",
            width: {
              xs: "100%", // Mobile
              sm: "100%", // Tablet small
              md: "100%", // Tablet landscape
              lg: "45%", // Desktop
            },
            border: "none",
            borderRadius: "6px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: {
              xs: "16px",
              sm: "20px",
              md: "30px",
              lg: "20px",
            },
            alignContent: "start",
            backgroundColor: "white",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              height: "100%",
              justifyContent: "space-evenly",
              flex: 3,
              // Safety net: if content is ever taller than the container
              // (e.g. an edge-case viewport height calc), scroll instead of
              // silently clipping the GO button off the bottom.
              overflowY: "auto",
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};
export default OmniDeviceLayout;